// extracted by mini-css-extract-plugin
export default {"section":"WorkoutDescriptionPage_section__doVfw"};